import { useSession } from "app/authv2/use-session"
import { useRouter } from "next/router"

interface ErrorReportData {
  name: string
  message: string
  stack?: string
  userId?: string
  userEmail?: string
  organizationId?: number
  organizationName?: string
  url: string
  pathname: string
  userAgent?: string
  timestamp: string
  environment?: string
  additionalContext?: Record<string, unknown>
}

export const reportError = async (error: Error, additionalContext?: Record<string, unknown>) => {
  try {
    const errorData: ErrorReportData = {
      name: error.name,
      message: error.message,
      stack: error.stack,
      url: window.location.href,
      pathname: window.location.pathname,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      environment: process.env.NODE_ENV,
      additionalContext
    }

    // Send to the new API endpoint
    const response = await fetch('/dash-api/v1/ops/error', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(errorData),
    })

    if (!response.ok) {
      console.error('Failed to report error:', response.statusText)
    }
  } catch (reportingError) {
    // Don't let error reporting errors break the app
    console.error('Error reporting failed:', reportingError)
  }
}

export const useErrorReporter = () => {
  const { data: session, userId, isLoading } = useSession()
  const router = useRouter()

  const reportErrorWithContext = async (error: Error, additionalContext?: Record<string, unknown>) => {
    const contextData = {
      ...additionalContext,
      userId: userId || undefined,
      userEmail: session?.email || undefined,
      currentRoute: router.pathname,
      routeQuery: router.query,
    }

    await reportError(error, contextData)
  }

  return { reportError: reportErrorWithContext }
}